export type Step = Readonly<{
    image: string;
    title: string;
    text: string;
}>;

export const DEFAULT_FEATURES: readonly Step[] = [
    { image: 'assets/images/features/Features1-400.webp', title: 'Domestic & International Flights', text: 'We cover the world with flight deals to both international and domestic locations.' },
    { image: 'assets/images/features/Features2-400.webp', title: 'SMS Text Alerts', text: `We'll text you whenever we find a flight deal to one of your dream locations.` },
    { image: 'assets/images/features/Features3-400.webp', title: 'Premium & Business Class', text: 'Get alerts for business & premium class flights, so you never miss luxury deals.' },
    { image: 'assets/images/features/Features4-400.webp', title: 'Member Only Flight Deals', text: 'We work directly with airlines to get discounts & flights not available to the public.' },
    { image: 'assets/images/features/Features5-400.webp', title: 'Dream Destinations', text: `We'll prioritize finding flight deals to your personalized selection of dream destinations.` },
    { image: 'assets/images/features/Features6-400.webp', title: 'Travel Perks & Discounts', text: 'Members get $1,000+ in immediate savings with perks and discounts from the top travel brands.' },
] as const;


export type Faqs = Readonly<{
    question: string;
    answer: string;
    open: boolean;
}>;
export const DEFAULT_FAQS: Faqs[]= [
    { question: 'Can I cancel my membership if it’s not the right fit?', answer: 'Yes, you can cancel your membership at any time for any reason in your account settings.', open: false },
    { question: 'What kind of flight deals will I receive?', answer: 'We search for deals to both international and domestic destinations. Premium+ members get access to business, premium economy, and economy class flights. Premium and Free members receive economy class deals.', open: false },
    { question: 'What are Dream Destinations, and why should I set them?', answer: 'Dream Destinations are the places you want to visit most. When you set yours, we prioritize finding deals to those locations. You can update them anytime in your flight preferences.', open: false },
    { question: 'Are there benefits beyond cheap flights?', answer: 'Absolutely! Premium+ members get exclusive Partner Perks, including discounts on airport lounges, apparel, tours, and more, so you can save beyond just flights.', open: false },
    { question: 'Do you send text alerts?', answer: 'Yes, we send dream destination text alerts to Premium+ members! When we find flights to one of your dream destinations we will text you directly to make sure you don’t miss out on the deal. You can opt-in or opt-out at any time.', open: false },
    { question: 'Can I book more than one ticket?', answer: 'Yes! Book as many tickets as you need—for yourself, friends, and family. They’ll thank you when they see the savings.', open: false },
    { question: 'What are departure airports, and can I change them?', answer: 'Your departure airports are your home airports. All of the deals we send you will depart from your set departure airports. Premium & Premium+ members can set up to 4 departure airports to maximize the deals they receive. Free members can set one. You can edit your departure airports in your flight preferences anytime, whether you\'re moving or just want more options.', open: false },
    { question: 'Do you service customers outside of the United States?', answer: 'Yes we do! We service customers in North and South America, the Caribbean, Europe, Australia, and New Zealand.', open: false },
];

export interface HowItWorks {
    image: string;
    title: string;
    description: string;
}
export const DEFAULT_HOW_IT_WORKS: HowItWorks[] = [
    { image: 'assets/images/how-it-works/HowItWorks1-400.webp', title: '1. Select your home airports', description: "Choose your favorite local international airports you'd like us to monitor for you." },
    { image: 'assets/images/how-it-works/HowItWorks2-400.webp', title: '2. Select dream destinations', description: "We'll search for deals to your dream destinations, plus surprise locations." },
    { image: 'assets/images/how-it-works/HowItWorks3-400.webp', title: '3. Get cheap flight alerts', description: "We’ll send email & SMS alerts when we find flights up to 90% off leaving your selected airport." }
];

export interface Testimonials {
    text: string;
    year: string;
    name: string;
    image: string;
    video: string;
}

export const DEFAULT_TESTIMONIALS: Testimonials[] = [
    {
        text: "I love Dollar Flight Club. It has given our family so many opportunities to travel.",
        year: "2021",
        name: "Zerylyn T." ,
        image: "assets/images/testimonials/Testimonials1-400.webp",
        video: "assets/images/testimonials/Zerlynn-DFC-Testimonial.mov"
    },
    {
        text: "I can honestly say, it's changed my life.",
        year: "2023",
        name: "Amir N.",
        image: "assets/images/testimonials/Testimonials2-400.webp",
        video: "assets/images/testimonials/Amir.mov"
    },
    {
        text: "Boston to Oahu for under $500. It was a once in a lifetime opportunity.",
        year: "2022",
        name: "Dinon H.",
        image: "assets/images/testimonials/Testimonials3-400.webp",
        video: "assets/images/testimonials/Dinon.mov"
    },
    {
        text: "Getting a Dollar Flight Club membership is one of the best decisions I've ever made.",
        year: "2023",
        name: "Brad S.",
        image: "assets/images/testimonials/Testimonials4-400.webp",
        video: "assets/images/testimonials/Brad-Cropped-Smaller-File-Size.mov"
    },
    {
        text: "I love Dollar Flight Club. It has given our family so many opportunities to travel.",
        year: "2021",
        name: "Zerylyn T." ,
        image: "assets/images/testimonials/Testimonials1-400.webp",
        video: "assets/images/testimonials/Zerlynn-DFC-Testimonial.mov"
    },
    {
        text: "I can honestly say, it's changed my life.",
        year: "2023",
        name: "Amir N.",
        image: "assets/images/testimonials/Testimonials2-400.webp",
        video: "assets/images/testimonials/Amir.mov"
    },
    {
        text: "Boston to Oahu for under $500. It was a once in a lifetime opportunity.",
        year: "2022",
        name: "Dinon H.",
        image: "assets/images/testimonials/Testimonials3-400.webp",
        video: "assets/images/testimonials/Dinon.mov"
    },
    {
        text: "Getting a Dollar Flight Club membership is one of the best decisions I've ever made.",
        year: "2023",
        name: "Brad S.",
        image: "assets/images/testimonials/Testimonials4-400.webp",
        video: "assets/images/testimonials/Brad-Cropped-Smaller-File-Size.mov"
    },
    {
        text: "I love Dollar Flight Club. It has given our family so many opportunities to travel.",
        year: "2021",
        name: "Zerylyn T." ,
        image: "assets/images/testimonials/Testimonials1-400.webp",
        video: "assets/images/testimonials/Zerlynn-DFC-Testimonial.mov"
    },
    {
        text: "I can honestly say, it's changed my life.",
        year: "2023",
        name: "Amir N.",
        image: "assets/images/testimonials/Testimonials2-400.webp",
        video: "assets/images/testimonials/Amir.mov"
    },
    {
        text: "Boston to Oahu for under $500. It was a once in a lifetime opportunity.",
        year: "2022",
        name: "Dinon H.",
        image: "assets/images/testimonials/Testimonials3-400.webp",
        video: "assets/images/testimonials/Dinon.mov"
    },
    {
        text: "Getting a Dollar Flight Club membership is one of the best decisions I've ever made.",
        year: "2023",
        name: "Brad S.",
        image: "assets/images/testimonials/Testimonials4-400.webp",
        video: "assets/images/testimonials/Brad-Cropped-Smaller-File-Size.mov"
    }
];
